import { css } from '@emotion/css';

export const dialogCss = css`
  .modal {
    max-width: 28rem;
    position: relative;

    .header {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 24px;
    }

    .content {
      padding: 16px;
      background: var(--colors-neutrals-30);
      border-radius: 8px;
      max-height: calc(100vh - 300px);
      overflow-y: auto;
      margin-bottom: 16px;
      gap: 1.5rem;
      display: flex;
      flex-direction: column;
      color: var(--colors-neutrals-90);

      p {
        font-size: 14px;
      }

      a {
        cursor: pointer;
        text-decoration: underline;
        color: var(--colors-primary-30);
      }
    }
  }
`;
